"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsRequest = void 0;
class NewsRequest {
    constructor(locale = null, title = '', description = '', body = '', category = [], createdUser = '', //IRI
    originalFilename = null, base64EncodedFile = null, customerGroups = [], departments = []) {
        this.locale = locale;
        this.title = title;
        this.description = description;
        this.body = body;
        this.category = category;
        this.createdUser = createdUser;
        this.originalFilename = originalFilename;
        this.base64EncodedFile = base64EncodedFile;
        this.customerGroups = customerGroups;
        this.departments = departments;
    }
}
exports.NewsRequest = NewsRequest;
